import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import Image from 'components/Image';
import styles from './index.module.scss';
import { images } from 'utils/icons';
import ModalImage from 'react-modal-image';
import cn from 'classnames';

const downloadMedia = url => {
  window.open(url);
};

const Media = ({ value, condense }) => {
  const [mediaPlay, setMediaPlay] = useState({});
  const musicRef = useRef([]);

  const handleMediaPlay = key => {
    if (Object.keys(mediaPlay).length === 1) {
      if (key !== mediaPlay.key) {
        musicRef.current[mediaPlay.key].pause();
        setMediaPlay({ key });
        musicRef.current[key].play();
        return;
      }
      musicRef.current[key].pause();
      setMediaPlay({});
    } else {
      musicRef.current[key].play();
      setMediaPlay({ key });
    }
    musicRef.current[key].onended = () => {
      setMediaPlay({});
    };
  };

  return (
    <div className={styles.container}>
      {value &&
        value.map((media, key) => {
          if (media.mediaType === 'IMAGE') {
            return (
              <div
                className={cn(styles.mediaPlayer, {
                  [styles.condense]: condense,
                })}
                key={key}
              >
                <Image
                  src={images.imageMedia?.default}
                  className={styles.mediaImage}
                />
                <ModalImage
                  small={media.url || images.imageMediaPlaceholder?.default}
                  large={media.url || images.imageMediaPlaceholder?.default}
                  className={styles.image}
                  hideDownload={true}
                />
              </div>
            );
          } else {
            return (
              <div
                className={cn(styles.mediaPlayer, {
                  [styles.condense]: condense,
                })}
                key={key}
              >
                <Image src={images.audioMedia} className={styles.mediaImage} />
                <audio
                  ref={ref => {
                    musicRef.current[key] = ref;
                  }}
                  className={styles.audio}
                >
                  <source src={media.url} type="audio/mpeg" />
                  <Image src={images.downloadMedia} onClick={downloadMedia}>
                    This browser does not support the HTML5 video element.
                  </Image>
                </audio>
                <Image
                  onClick={() => handleMediaPlay(key)}
                  className={cn(styles.center, { [styles.pointer]: media.url })}
                  src={
                    media.url
                      ? mediaPlay?.key === key
                        ? images.pauseMedia
                        : images.playMedia
                      : images.audioMediaPlaceholder
                  }
                />
              </div>
            );
          }
        })}
    </div>
  );
};

Media.propTypes = {
  value: PropTypes.arrayOf(
    PropTypes.shape({
      mediaType: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }),
  ),
  condense: PropTypes.bool,
};

export default Media;
